/* Browser shim that replaces the sandbox-only window.claude.complete().
 *
 * POSTs to the same-origin /api/claude serverless function, which holds the
 * ANTHROPIC_API_KEY and forwards to https://api.anthropic.com/v1/messages.
 *
 * Returns the assistant text content as a string (matching the contract of
 * window.claude.complete so real-fill.js can stay almost unchanged).
 */

import { DEFAULT_MODEL } from './models.js';

const DEFAULT_MAX_TOKENS = 8192;

export async function complete({
  messages,
  system,
  model = DEFAULT_MODEL,
  maxTokens = DEFAULT_MAX_TOKENS,
  signal,
}) {
  const res = await fetch('/api/claude', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ model, max_tokens: maxTokens, system, messages }),
    signal,
  });

  if (!res.ok) {
    let detail = '';
    try { detail = (await res.json()).error || ''; } catch { /* ignore */ }
    throw new Error(`/api/claude ${res.status}${detail ? ` — ${detail}` : ''}`);
  }

  const body = await res.json();
  if (typeof body.text !== 'string') {
    throw new Error('/api/claude returned no text field');
  }
  return body.text;
}

export const claudeProxy = { complete };
